import Popup from '@root/core/components/Popup';
import Validate from '@root/core/validate';
import { Button, Card, Spin, message } from 'antd';
import { useRef, useState } from 'react';
import { useHistory } from 'react-router';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import ShippingServices from '@root/modules/Sellers/Shipping/services/shipping';
import Excel from '@root/utils/helpers/excel';


const ShippingRequestCSV = () => {
  const history = useHistory();
  const [fileName, setFileName] = useState('');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState<FormData>();
  const inputFileName = useRef<HTMLInputElement | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const listBreadcrumb = [
    {
      tittle: '배송 관리',
      url: '/admin/seller/shipping'
    },
    {
      tittle: '배송 등록',
      url: '/admin/seller/shipping'
    },
    {
      tittle: 'CSV 파일 업로드',
      url: ''
    }
  ];

  const onFileChange = (files: FileList | null) => {
    if (files && files.length) {
      const file = files[0];
      setFileName(file.name);

      const fm = new FormData();
      fm.append('file', file);
      setForm(fm);
    }
  }

  const handleDownload = async () => {
    const excelOption = {
      blod: await ShippingServices.getTemplateShippingCSV(),
      originalName: 'DeliveryCSV'
    };
    Excel.download(excelOption);
  }

  const handleConfirm = () => {
    if (form) {
      setIsModalOpen(true)
    } else {
      Validate.warningEmpty(inputFileName);
    }
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await ShippingServices.createShippingCSV(form!);
      message.success(res.massage);

      history.push('/admin/seller/shipping');
    } catch (error: any) {
      const { response } = error;
      if (response?.data?.message) {
        message.error(response.data.message);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <BreadcrumbList listBreadcrumb={listBreadcrumb} />
      <div>
        <Spin spinning={loading}>
          <Card
            bordered={false}
            className="admin-card"
            style={{
              minHeight: '80vh',
              margin: '40px 20px 20px 20px'
            }}
          > 
            <div>
              <div
                style={{
                  padding: '0.5rem 1.5rem',
                  marginTop: '1.5rem',
                  backgroundColor: '#F9F9F9',
                  borderRadius: '0.5rem',
                  display: 'flex'
                }}
              >
                <div>
                  <strong>💡 안내사항</strong>
                  <ol style={{marginTop: '20px', fontWeight: '300'}}>
                    <li>CSV 파일로 배송 등록 시에는 버스크풀필먼트 양식에 맞는 CSV 파일이 필요합니다. 우측 상단의 <b style={{fontWeight: 'bold'}}>템플릿 다운로드</b> 버튼을 눌러 다운로드 해주세요! </li>
                    <li>양식에 맞게 작성해주신 후, 해당 파일을 아래 첨부파일 등록란에 등록해주세요.</li>
                    <li><b style={{fontWeight: 'bold'}}>배송요청</b> 버튼을 누르면 배송 등록 완료! 등록된 사항은 <b style={{fontWeight: 'bold'}}>배송 조회</b> 메뉴에서 확인할 수 있습니다.</li>
                  </ol>
                </div>
                <div className='right'>
                  <Button onClick={handleDownload}>템플릿 다운로드</Button>
                </div>
              </div>
              <div style={{marginTop: '40px'}}>
                <p>첨부파일 등록</p>
                <div style={{display: 'flex'}}>
                  <input ref={inputFileName} readOnly={true} style={{flex: 1}} value={fileName}/>
                  <div style={{flex: 2, paddingLeft: '10px'}}>
                    <label className='ant-btn ant-btn-primary' style={{cursor: 'pointer', background: '#3c3d5f', border: 'none', paddingLeft: '30px', paddingRight: '30px'}}>
                      업로드
                      <input className="d-none" type="file"
                        accept=".xlsx, .xls"
                        onChange={(e) => {
                          onFileChange(e.target.files);
                          e.target.value = '';
                        }}
                      />
                      </label>
                  </div>
                </div>
              </div>
              <div style={{position: 'absolute', bottom: 0, right: 0, padding: '0 24px 24px 0'}}>
                <Button
                  type="primary"
                  onClick={handleConfirm}
                  style={{cursor: 'pointer', background: '#3c3d5f', border: 'none', padding: '0 30px'}}
                >
                  배송 요청
                </Button>
              </div>
            </div>
          </Card>
        </Spin>
      </div>

      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        textCancel="취소"
        textOk="확인"
        visible={isModalOpen}
        title="배송 요청 하시겠습니까?"
        action_oke={() => {
          handleSubmit();
          setIsModalOpen(false);
        }}
        action_cancel={() => {
          setIsModalOpen(false);
        }}
      />
    </>
  );
};
export default ShippingRequestCSV;
